<template>
    <div style="width:1400px; margin:0 auto;">
        <div style="width:1400px; margin:0 auto; padding:10px 20px; background:#fff;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class='l12payeveryday_ctrl'>
            <div class="l12runoff_block">
                <h2>留存概况</h2>
                <div class="l12runoff_block_content">
                    <div class="l12payeveryday_searchbar">
                        <a-form class="search_form" layout="inline">
                            <a-form-item label="日期段">
                                <a-range-picker  v-model="overview.params.dt" :allowClear="false" style="width:210px"/>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select  style="width: 130px" v-model="overview.params.retention_id_type" :options="options.retention_type" />
                            </a-form-item>
                            <a-form-item>
                                <a-radio-group v-model="overview.type">
                                    <a-radio-button value="os_name">平台</a-radio-button>
                                    <a-radio-button value="server">服务器</a-radio-button>
                                    <a-radio-button value="channel">渠道</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item>
                                <a-select v-model="overview.params.retention_os_name" style="width: 210px" :options="options.os" mode="multiple" :maxTagCount="5" v-if="overview.type=='os_name'" placeholder="请选择平台，默认全选"></a-select>
                                <a-select v-model="overview.params.retention_app_channel" style="width: 210px" :options="options.appchannel" mode="multiple" :maxTagCount="5" v-if="overview.type=='channel'" placeholder="请选择渠道，默认全选"></a-select>
                                <Server v-model="overview.params.retention_server" pos="left" v-if="overview.type=='server'"/>
                            </a-form-item>
                            <a-form-item>
                                <a-button type="primary" html-type="submit" @click="getData('overview')">查询</a-button>
                            </a-form-item>
                        </a-form>
                    </div>
                    <a-tabs>
                        <a-tab-pane tab="留存率">
                            <a-radio-group v-model="overview.params.retention_is_new">
                                <a-radio-button value="new">新增</a-radio-button>
                                <a-radio-button value="active">活跃</a-radio-button>
                            </a-radio-group>
                            <a-button-group style="float:right; margin:0 0 10px 10px" >
                                <a-button @click="lockHeader('overview_retention_table')" :type="locks.indexOf('overview_retention_table')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('overview_retention_table')>=0?'取消固定':'固定表头'}}</a-button>
                                <a-button @click="exportToExcel('overview_retention_table','留存概况-留存率')"><a-icon type="download"/>下载数据</a-button>
                                <a-button @click="copy('overview_retention_table')" id="copy-btn"><a-icon type="copy"/>复制数据</a-button>
                            </a-button-group>
                            <DataTable :fields="overview.data.fields" :datas="overview.data.list" style="margin:30px 0;" ref="overview_retention_table"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
            <div class="l12runoff_block">
                <h2>流失对比分析</h2>
                <div class="l12runoff_block_content">
                    <div class="l12payeveryday_searchbar">
                        <a-form class="search_form" layout="inline">
                            <a-form-item>
                                <a-form-item>
                                    <a-date-picker placeholder="选择查询日期" v-model="liushi.params.start_dt" :allowClear="false"/>
                                </a-form-item>
                                <a-form-item>
                                对比
                                </a-form-item>
                                <a-form-item>
                                    <a-date-picker placeholder="选择对比日期" v-model="liushi.params.end_dt" :allowClear="false"/>
                                </a-form-item>
                            </a-form-item>
                            <a-form-item label="类型">
                                <a-select  style="width: 130px" v-model="liushi.params.runoff_id_type" :options="options.retention_type2" />
                            </a-form-item>
                            <a-form-item label="留存率">
                                <a-select  style="width: 130px" v-model="liushi.params.runoff_day_type" :options="options.liushi" />
                            </a-form-item>
                            <a-form-item>
                                <a-button type="primary" html-type="submit" @click="getData('liushi')">查询</a-button>
                            </a-form-item>
                        </a-form>
                    </div>
                    <a-tabs v-model="liushi.tab">
                        <a-tab-pane :tab="tab.tab" v-for="tab in liushi.tabs" :key="tab.key">
                        </a-tab-pane>
                    </a-tabs>
                    <a-radio-group v-model="liushi.params.runoff_is_new">
                        <a-radio-button value="new">新增</a-radio-button>
                        <a-radio-button value="active">活跃</a-radio-button>
                    </a-radio-group>
                    <a-radio-group v-model="liushi.display" style="float:right; margin:0 0 0 16px;">
                        <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                        <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                    </a-radio-group>
                    <a-button-group style="float:right; margin:0 0 10px 10px" v-if="liushi.display=='table'">
                        <a-button @click="lockHeader('liushi_table')" :type="locks.indexOf('liushi_table')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('liushi_table')>=0?'取消固定':'固定表头'}}</a-button>
                        <a-button @click="exportToExcel('liushi_table',`流失对比分析-${liushi.tab=='runoff_level'?'等级流失':liushi.tab=='runoff_vip'?'vip流失':'分钟流失'}`)"><a-icon type="download"/>下载数据</a-button>
                        <a-button @click="copy('liushi_table')" id="copy-btn"><a-icon type="copy"/>复制数据</a-button>
                    </a-button-group>
                    <Chart :conf="liushi.chart" :datas="liushi.data.list" :fields="liushi.data.fields" style="margin:30px 0;" v-if="liushi.display=='chart'"/>
                    <DataTable :fields="liushi.data.fields" :datas="liushi.data.list" style="margin:30px 0;" ref="liushi_table" v-if="liushi.display=='table'"/>
                </div>
            </div>
            <!-- <div class="l12runoff_block">
                <h2>角色留存波动分析</h2>
                <div class="l12runoff_block_content">
                    <div class="l12payeveryday_searchbar">
                        <a-form class="search_form" layout="inline">
                            <a-form-item label="日期段">
                                <a-range-picker v-model="liucun.params.dt" :allowClear="false" style="width:210px"/>
                            </a-form-item>
                            <a-form-item label="留存率">
                                <a-select  style="width: 130px" v-model="liucun.params.wave_day_type" :options="options.liucun" />
                            </a-form-item>
                            <a-form-item>
                                <a-radio-group v-model="liucun.type">
                                    <a-radio-button value="os_name">平台</a-radio-button>
                                    <a-radio-button value="server">服务器</a-radio-button>
                                    <a-radio-button value="channel">渠道</a-radio-button>
                                    <a-radio-button value="vip">VIP</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item>
                                <a-select v-model="liucun.params.wave_os_name" style="width: 210px" :options="options.os" mode="multiple" :maxTagCount="5" v-if="liucun.type=='os_name'" placeholder="请选择平台，默认全选"></a-select>
                                <a-select v-model="liucun.params.wave_app_channel" style="width: 210px" :options="options.appchannel" mode="multiple" :maxTagCount="5" v-if="liucun.type=='channel'" placeholder="请选择渠道，默认全选"></a-select>
                                <Server v-model="liucun.params.wave_server" pos="left" v-if="liucun.type=='server'"/>
                                <a-select v-model="liucun.params.wave_app_channel" style="width: 210px" :options="options.vip" mode="multiple" :maxTagCount="5" v-if="liucun.type=='vip'" placeholder="请选择VIP，默认全选"></a-select>
                            </a-form-item>
                            <a-form-item>
                                <a-button type="primary" html-type="submit" @click="getData('liucun')">查询</a-button>
                            </a-form-item>
                        </a-form>
                    </div>
                    <a-tabs>
                        <a-tab-pane tab="留存率">
                            <a-radio-group v-model="liucun.params.wave_is_new">
                                <a-radio-button value="new">新增</a-radio-button>
                                <a-radio-button value="active">活跃</a-radio-button>
                            </a-radio-group>
                            <a-radio-group v-model="liucun.display" style="float:right; margin:0 0 0 16px;">
                                <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                                <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                            </a-radio-group>
                            <a-button-group style="float:right; margin:0 0 10px 10px" v-if="liucun.display=='table'">
                                <a-button @click="lockHeader('liucun_table')" :type="locks.indexOf('liucun_table')>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf('liucun_table')>=0?'取消固定':'固定表头'}}</a-button>
                                <a-button @click="exportToExcel('liucun_table','留存波动分析')"><a-icon type="download"/>下载数据</a-button>
                                <a-button @click="copy('liucun_table')" id="copy-btn"><a-icon type="copy"/>复制数据</a-button>
                            </a-button-group>
                            <Chart :conf="liucun.chart" :datas="liucun.data.list" :fields="liucun.data.fields" style="margin:30px 0;" v-if="liucun.display=='chart'"/>
                            <DataTable :theads="liucun.data.theads" :fields="liucun.data.fields" :datas="liucun.data.list" style="margin:30px 0;" ref="liucun_table" v-if="liucun.display=='table'"/>
                        </a-tab-pane>
                    </a-tabs>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import Server from '@/components/common/search/server.vue'
import moment from "moment"
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import {Form, DatePicker, Input, Select} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Form)
Vue.use(Select)
export default {
    mixins: [ctrlMixin],
    name:'l12runoff',
    props: ['parent', 'name'],
    components: {
        DataTable,
        Chart,
        Server,
    },
    mounted(){
        this.initConfig()
        this.initData()
    },
    watch: {
        'overview.params.retention_is_new'(newV) {
            this.getData('overview')
        },
        'overview.type'(newV) {
            this.overview.params.retention_os_name = []
            this.overview.params.retention_app_channel = []
            this.overview.params.retention_server = []
        },
        'liushi.params.runoff_is_new'(newV) {
            this.getData('liushi')
        },
        'liushi.tab'(newV) {
            this.getData('liushi')
        },
        'wave.params.wave_is_new'(newV) {
            this.getData('liucun')
        },
        'liucun.type'(newV) {
            this.liucun.params.wave_os_name = []
            this.liucun.params.wave_app_channel = []
            this.liucun.params.wave_server = []
            this.liucun.params.wave_vip = []
        },
    },
    data() {
        return {
            options: {os:[], vip:[], appchannel:[]},
            overview: {
                type:'os_name',
                params:{
                    date: [],
                    retention_id_type:'account',
                    retention_is_new: 'new',
                },
                data: {},
            },
            liushi: {
                tab:'runoff',
                display:'chart',
                tabs: [
                    {tab: '分钟流失', key: 'runoff'},
                    {tab: '等级流失', key: 'runoff_level'},
                    {tab: 'VIP等级流失', key:'runoff_vip'}
                ],
                params: {
                    start_dt: null,
                    end_dt: null,
                    runoff_id_type:'account',
                    runoff_day_type:'runoff_next',
                    runoff_is_new: 'new',
                },
                data: {},
            },
            liucun: {
                display:'chart',
                type: 'os_name',
                tabs: [
                    {tab: '分钟流失', key: 'runoff'},
                    {tab: '等级流失', key: 'runoff_level'},
                    {tab: 'VIP等级流失', key:'runoff_vip'}
                ],
                params: {
                    date: [],
                    wave_day_type:'retention_next',
                    wave_is_new: 'new',
                },
                data: {},
            },
        }
    },
    methods: {
        initConfig() {
            // 获取日期初始值
            function  getDate(val) {
                if(typeof(val) == 'number') {
                    if(val > 0) {
                        return moment(new Date()).add(val, 'days')
                    } else if (val < 0){
                        return moment(new Date()).subtract(-val, 'days')
                    } else {
                        return moment(new Date())
                    }
                }
                else if(typeof(val) == 'string') {
                    return moment(val)
                }
                else {
                    return moment(new Date()).subtract(1, 'days')
                }
            }
            // 初始化日期
            let dtConfig = _.find(this.config.searchers, {id:'dt'})
            if(dtConfig && dtConfig.default && dtConfig.default instanceof Array) {
                let dts = []
                if(dtConfig.default.length>0) {
                    let start_dt = getDate(dtConfig.default[0])
                    dts.push(start_dt)
                    this.liushi.params.start_dt = start_dt
                }
                if(dtConfig.default.length>1) {
                    let end_dt = getDate(dtConfig.default[1])
                    dts.push(end_dt)
                    this.liushi.params.end_dt = end_dt
                }
                this.overview.params.dt = dts
                this.liucun.params.dt =_.cloneDeep(dts)
            }
            //初始化图表
            if(this.modules && this.modules.length>0) {
                this.liushi.chart = this.modules[0].chart
            }

            this.$service.query(this.queryId, {init:true}).then((data)=>{
                if(data.os) {
                    let oss = []
                    data.os.forEach((os)=>{
                        let new_os = {label:os.value, value:os.id}
                        oss.push(new_os)
                    })
                    data.os = oss
                }
                if(data.vip) {
                    let vips = []
                    data.vip.forEach((vip)=>{
                        let new_vip = {label:vip.value, value:vip.id}
                        vips.push(new_vip)
                    })
                    data.vip = vips
                }
                if(data.appchannel) {
                    let channels = []
                    data.appchannel.forEach(channel=>{
                        let new_channel = {label:channel[1], value:channel[0]}
                        channels.push(new_channel)
                    })
                    data.appchannel=channels
                }
                this.options = data
                this.options.retention_type = [
                    {label:"账号", value:"account"},
                    {label:"角色", value:"role"},
                    {label:"设备", value:"device"}]
                this.options.retention_type2 = [
                    {label:"账号", value:"account"},
                    {label:"角色", value:"role"}]
                this.options.liushi = [
                    { value: 'runoff_next', label: '次日流失率' },
                    { value: 'runoff_three', label: '3日流失率' },
                    { value: 'runoff_seven', label: '7日流失率' },
                    { value: 'runoff_fifteen', label: '15日流失率' }]
                this.options.liucun = [
                    { value: 'retention_next', label: '次日留存率' },
                    { value: 'retention_seven', label: '7日留存率' },
                    { value: 'retention_fifteen', label: '15日留存率' },]
            })
        },
        get_multiple(multiplefields) {
            let theads = []
            let newfields = []
            let sub_index = 0
            if(multiplefields.length>0) {
                multiplefields[0].forEach((f)=>{
                    let field = Object.assign({}, f)
                    if(f['tooltip'])
                        field['desc'] = f['tooltip']
                    
                    if(!f['colspan']) {
                        theads.push(field)
                        newfields.push(field)
                    }
                    else {
                        field['children'] = []
                        if(multiplefields.length>=2) {
                            for(let index=sub_index; index<sub_index + f['colspan']; index+=1) {
                                let f2 = multiplefields[1][index]
                                let field2 = Object.assign({}, f2)
                                let field22 = Object.assign({}, f2)
                                field22['title']  = f['title']+f2['title']
                                if(f2['tooltip']) {
                                    field2['desc'] = f2['tooltip']
                                    field22['desc'] = f2['tooltip']
                                }
                                field['children'].push(field2)
                                newfields.push(field22)
                            }
                        }
                        sub_index+=f['colspan']
                        theads.push(field)
                    }
                })
                if(multiplefields.length>=2 && sub_index<multiplefields[1].length-1) {
                    for(let index = sub_index+1; index<multiplefields[1].length; index+=1) {
                        let f2 = multiplefields[1][index]
                        let field2 = Object.assign({}, f2)
                        let field22 = Object.assign({}, f2)
                        if(f2['tooltip']) {
                            field2['desc'] = f2['tooltip']
                            field22['desc'] = f2['tooltip']
                        }
                        newfields.push(field22)
                    }
                }
            }
            return [theads, newfields]
        },
        initData() {
            this.getData('overview')
            this.getData('liushi')
        },
        getData(type, subtype) {
            this.loading = true
            if(type=='overview') {
                let params = Object.assign({retention_type: "retention", retention_subtitle:"retention",}, this.overview.params)
                params["retention_start"] = params.dt[0].format('YYYY-MM-DD')
                params["retention_end"] = params.dt[1].format('YYYY-MM-DD')
                params["retention_os_name"] = !params["retention_os_name"] || params["retention_os_name"].length==0?"all":_.join(params["retention_os_name"], ',')
                params["retention_app_channel"] = !params["retention_app_channel"] || params["retention_app_channel"].length==0?"all":_.join(params["retention_app_channel"], ',')
                params["retention_server"] = !params["retention_server"] || params["retention_server"].length==0?"all":_.join(params["retention_server"], ',')
                
                this.$service.query(this.queryId, params).then((data)=>{
                    this.overview.data = data
                    this.loading = false
                }).catch((data)=> {
                    this.loading = false
                })
            }
            if(type=='liushi') {
                let params = Object.assign({runoff_type: "runoff", runoff_subtitle:this.liushi.tab,}, this.liushi.params)
                params["runoff_start"] = params.start_dt.format('YYYY-MM-DD')
                params["runoff_end"] = params.end_dt.format('YYYY-MM-DD')
                
                this.$service.query(this.queryId, params).then((data)=>{
                    this.liushi.data = data
                    this.loading = false
                }).catch((data)=> {
                    this.loading = false
                })
            }
            if(type=='liucun') {
                let params = Object.assign({wave_type: "retention_wave", wave_subtitle:this.liucun.type,}, this.liucun.params)
                params["wave_start"] = params.dt[0].format('YYYY-MM-DD')
                params["wave_end"] = params.dt[1].format('YYYY-MM-DD')
                params["wave_os_name"] = !params["wave_os_name"] || params["wave_os_name"].length==0?"all":_.join(params["wave_os_name"], ',')
                params["wave_app_channel"] = !params["wave_app_channel"] || params["wave_app_channel"].length==0?"all":_.join(params["wave_app_channel"], ',')
                params["wave_server"] = !params["wave_server"] || params["wave_server"].length==0?"all":_.join(params["wave_server"], ',')
                params["wave_vip"] = !params["wave_vip"] || params["wave_vip"].length==0?"all":_.join(params["wave_vip"], ',')
                
                this.$service.query(this.queryId, params).then((data)=>{
                    let multips = this.get_multiple(data.multiplefields)
                    let result = {}
                    let theads=multips[0], fields = multips[1] 
                    result.theads = theads
                    result.fields = fields
                    result.list = data.list
                    this.liucun.data = result
                    this.loading = false
                }).catch((data)=> {
                    this.loading = false
                })
            }
        },
        exportToExcel(table, name) {
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].exportToExcel(name)
            }
            else {
                this.$refs[table].exportToExcel(name)
            }
        },
        copy(table) {
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].copy()
            }
            else {
                this.$refs[table].copy()
            }
        },
        lockHeader(table) {
            let lock = false
            let lock_index = this.locks.indexOf(table)
            if(lock_index>=0) {
                lock = true
                this.locks.splice(lock_index,1)
            }
            else {
                this.locks.push(table)
            }
            
            if(this.$refs[table] instanceof Array) {
                this.$refs[table][0].lockHeader(!lock)
            }
            else {
                this.$refs[table].lockHeader(!lock)
            }
        },
    }
}
</script>
<style lang="less" scoped>
@width:1400px;

.l12payeveryday_ctrl {
    width:@width;
    margin:0 auto;
    overflow: hidden;
    .l12runoff_block {
        background:#fff;
        margin:0 0 24px 0;
        h2 {
            padding: 10px 20px;
            border-bottom: 1px solid #ddd;
            font-weight: bold;
            line-height: 32px;
        }
        .l12runoff_block_content {
            padding: 20px 30px;
            min-height: 200px;
        }
    }
    .l12payeveryday_searchbar {
        margin:0 0 20px 0;
    }
}

</style>